angular
  .module('contrast.factory.attack.monitor', [])
  .factory('AttackMonitorFactory', function ($http, $q, UserService) {
    return {
      getTopTargetedApps: function (form) {
        return promisifyGet('/rasp/monitor/apps', form)
      },
      getTopAttackers: function (form) {
        return promisifyGet('/rasp/monitor/attackers', form)
      },
      getTopEvents: function (form) {
        return promisifyGet('/rasp/monitor/events', form)
      },
      getStats: function () {
        return $http.get(UserService.buildAPIUrl('/rasp/monitor/stats'))
      },
      getFilters: function (form) {
        return promisifyGet('/rasp/monitor/filter', form)
      },
      getTimeline: function () {
        return $http.get(UserService.buildAPIUrl('/rasp/monitor/timeline'))
      }
    }

    function promisifyGet(url, form) {
      var httpTimeout = $q.defer()

      var request = $http({
        method: 'get',
        url: UserService.buildAPIUrl(url),
        params: form,
        timeout: httpTimeout.promise
      })

      var promise = request.then()
      promise._httpTimeout = httpTimeout
      return promise
    }
  })
